import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableSettingsTabEnum } from '@shared-modules/table-shared/_core/enums/table-setting-tab.enum';
import { SortOrderEnum } from '@shared/enums';
import { TableColumn } from '@shared/interfaces';
import { orderBy } from 'lodash';
import { ButtonModule } from 'primeng/button';
import { FocusTrapModule } from 'primeng/focustrap';
import { SidebarModule } from 'primeng/sidebar';
import { TabViewModule } from 'primeng/tabview';
import { SortTableComponent } from './sort-table/sort-table.component';

@Component({
    selector:
        'app-sort-and-filter-drawer[selectedTab][closeDrawer][columns][resetFilters][sortChanged][isSortRestoreDisabled][isFilterRestoreDisabled]',
    standalone: true,
    imports: [TranslateModule, ButtonModule, SidebarModule, TabViewModule, SortTableComponent, FocusTrapModule],
    templateUrl: './sort-and-filter-drawer.component.html',
    styleUrls: ['./sort-and-filter-drawer.component.scss'],
})
export class SortAndFilterDrawerComponent implements OnChanges {
    @Input() columns: TableColumn<any>[] = [];
    @Input() isVisible = false;
    @Input() selectedTab = TableSettingsTabEnum.FILTER;
    @Input() defaultSortData!: TableColumn<any>[];
    @Input() isSortRestoreDisabled = false;
    @Input() isFilterRestoreDisabled = false;
    @Output() closeDrawer = new EventEmitter<void>();
    @Output() resetFilters = new EventEmitter<void>();
    @Output() sortChanged = new EventEmitter<TableColumn<any>[]>();

    readonly tabs = TableSettingsTabEnum;

    sortableColumns: TableColumn<any>[] = [];

    ngOnChanges(): void {
        this.sortableColumns = this.columns.filter(c => c.isSortingEnabled);
    }

    close(): void {
        this.closeDrawer.emit();
    }

    resetFiltersButtonClick(): void {
        this.resetFilters.emit();
    }

    resetSortButtonClick(): void {
        this.columns.forEach(column => {
            const initialColumnData = this.defaultSortData.find(defaultColumn => defaultColumn.field === column.field);

            if (initialColumnData) {
                column.sortPriority = initialColumnData.sortPriority;
                column.sortOrder = initialColumnData.sortOrder;
                column.isSortingActive = initialColumnData.isSortingActive;
            } else {
                column.sortOrder = SortOrderEnum.ASC;
                column.sortPriority = null;
                column.isSortingActive = false;
            }
        });
        this.sortableColumns = orderBy(this.columns, ['sortPriority']).filter(column => column.isSortingActive);
        this.sortChanged.emit(this.sortableColumns);
    }

    changeTab(event: { index: TableSettingsTabEnum }): void {
        this.selectedTab = event.index;
    }

    changeSort(columns: TableColumn<any>[]): void {
        this.sortChanged.emit(columns);
    }
}
